import React from 'react'
import { Link } from 'gatsby'
import clsx from 'clsx'
import { useLocation } from '@reach/router'
import latestReleases from '../../legacy/docs/_data/latest-releases.json'

const isDocs = () => {
  const { pathname } = useLocation()
  return pathname === '/docs'
}

const isCommunity = () => {
  const { pathname } = useLocation()
  return ['/getting-help', '/reporting-bugs', '/requesting-features', '/contributing'].includes(
    pathname
  )
}

export const TopBar: React.FC = () => {
  return (
    <header className='topbar'>
      <div className='topbar__container container'>
        <div className='topbar__branding'>
          <Link className='branding' to='/'>
            <div className='branding-graphic'></div>
            <div className='branding-text'>FullCalendar</div>
          </Link>
        </div>

        <nav className='topbar__nav'>
          <div className='topbar__nav-item' id='demos-nav-item'>
            <a className='topbar__nav-handle' href='/demos'>
              Demos
            </a>
          </div>
          <div className={clsx('topbar__nav-item', isDocs() ? 'topbar__nav-item--selected' : '')}>
            <a className='topbar__nav-handle' href='/docs'>
              Docs
            </a>
          </div>
          <div
            className={clsx('topbar__nav-item', isCommunity() ? 'topbar__nav-item--selected' : '')}
          >
            <div className='topbar__nav-handle'>Support</div>
            <div className='topbar__flyout-wrap'>
              <div className='topbar__flyout'>
                <div className='topbar__flyout-item'>
                  <Link className='topbar__flyout-handle' to='/getting-help'>
                    Getting Help
                  </Link>
                </div>
                <div className='topbar__flyout-item'>
                  <Link className='topbar__flyout-handle' to='/reporting-bugs'>
                    Reporting Bugs
                  </Link>
                </div>
                <div className='topbar__flyout-item'>
                  <Link className='topbar__flyout-handle' to='/requesting-features'>
                    Requesting Features
                  </Link>
                </div>
                <div className='topbar__flyout-item'>
                  <Link className='topbar__flyout-handle' to='/contributing'>
                    Contributing
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className='topbar__nav-item'>
            <Link
              className='topbar__nav-handle button button--lightblue button--outlined'
              to='/pricing'
            >
              Pricing
            </Link>
          </div>
        </nav>

        <div className='topbar__notice'>
          {/* FIXME: keep this in sync with legacy/docs/_includes/topbar.html */}
          <a
            className='topbar__notice-link'
            href='https://github.com/fullcalendar/fullcalendar/releases'
            target='_blank'
            rel='noreferrer'
          >
            <span style={{ color: '#FAC863' }}>Latest:</span>&nbsp;
            v{latestReleases.v6}
          </a>
          {/*
            <a
              className='topbar__notice-link'
              href='https://github.com/fullcalendar/fullcalendar/issues/7907'
              target='_blank'
              rel='noreferrer'
            >
              <span style={{ color: '#FAC863' }}>Mar 28th</span> &mdash;
              v7 delayed for more features
            </a>
          */}
          {/*
            <Link
              className='topbar__notice-link'
              to='/blog/2023/01/multimonth-and-more'
            >
              <span style={{ color: '#FAC863' }}>Jan 27</span> &mdash;
              Multi-Month &amp; more in v6.1
            </Link>
          */}
        </div>

        <div className='topbar__github'>
          <a
            className='topbar__github-link'
            href='https://github.com/fullcalendar/fullcalendar'
            target='_blank'
            rel='noreferrer'
          >
            <div className='topbar__github-graphic'></div>
          </a>
        </div>
      </div>
    </header>
  )
}
